import React, { Component } from 'react';
import {
    MyPATTextArea,
    MyPATExpansionPanel,
    MyPATDialog,
} from "../../../common";
import AddConceptOrChapter from './AddConceptOrChapter';
import DeletePopUp from './wrapperComponent/popUps';
import CloseIcon from '@material-ui/icons/Close';
import AddExtraTags from './AddExtraTags';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
    Typography, createStyles, WithStyles, Button, Grid, DialogContent, IconButton, Dialog, DialogTitle
} from '@material-ui/core';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { showMsg } from '../../../course/actions/loaderAlert';

import {
    NavigateBeforeOutlined as BackIcon,
} from "@material-ui/icons";
import WithContent from "../../containers/WithContent";
import { notesActions } from '../../reducers/notesReducers';
import { showVideoModal } from '../../actions/showVideoProgressActions';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import WrapperComponent from './wrapperComponent/wrapperTabs';
import { VideoTab, TheoryTab, QuestionTab,AudioTab, ObjectiveQuestionTab } from './CreateNoteTabs';
import contentService from '../../services/contentService';
import videoServices from '../../services/videoServices';
import contentActions from '../../actions/contentActions';
import { studyActions } from '../../reducers/notesStateReducers';
import { getQuestionType, isQuestionTypeAllowed } from '../../helper/questionTab';
import cx from "classnames";
import MyPATUploader, { Attachment } from "../../../common/MyPATUploader";
import MyPATUploadPreview, { convertFileOrUrlToPreviewItem } from '../../../common/MyPATUploadPreview';
import { Error } from "@material-ui/icons";
import DropZone from '../../../common/DropZone';
import { PageChangeEvent, ProgressBar, Worker } from '@react-pdf-viewer/core';
import { DocumentLoadEvent,Viewer } from '@react-pdf-viewer/core';
import MyPATBaseSection, { SectionFocusedContext, SectionFocusedContextValue } from '../../../common/MyPATBaseSection';
import '@react-pdf-viewer/core/lib/styles/index.css';
import PDFViewer from './PDFViewer';
import * as LZString from 'lz-string';
import CreateNotes from './CreateNotes';
import CreateSubjectiveNotes from './CreateSubjectiveNotes';
import CreateObjectiveNotes from './CreateObjectiveNotes';
import { ARCHIVE_NOTES, CONTENT_SECTION_KEYS, CONTENT_SECTION_TYPES, CONTENT_TYPE, CREATE_NOTES_TABS, NOTES_SECTION, NOTES_TYPE, OBJECTIVE_NOTES, SUBJECTIVE_NOTES } from '../../../../constants/comman';

const updater = (action: string, value: number) => {
    switch (action) {
        case "INCREMENT":
            return value + 1;
        case "DECREMENT":
            return value - 1;
        default:
            return null;
    }
};

const styles = (theme: Theme) => createStyles({
    root: {
        flex: 'grow'
    },
    fileInfo: {
        fontSize: 12,
        lineHeight: "16px",
        color: "#999",
        display: "block",
        fontWeight: "normal",
        marginLeft: "-20px"

      },
    tabsAlign: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    textAlignRight: {
    textAlign: "right"
    },
    addButtonAlign: {
        display: 'flex',
        alignContent: 'center',
        // flexDirection: 'row-reverse'
    },
    chooseFromLibraryButton: {
        display: 'flex',
        alignContent: 'center',
        justifyContent: 'space-around'

    },
    mb1x: {
        marginBottom: theme.spacing.unit
    },
    // oRText: {
    //     display: 'flex',
    //     marginBottom: theme.spacing.unit,
    //     justifyContent: 'space-around'

    // },
    questionParagraph: {
        maxWidth: 380,
        '& >p': {
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            margin: '0',
        }
    },
    questionInfo: {
        border: `1px solid ${theme.palette.grey[300]}`,
        "& > div": {
            padding: `0 ${theme.spacing.unit}px`
        },
        "& > div:first-child": {
            paddingTop: theme.spacing.unit,
            paddingBottom: theme.spacing.unit,
            borderRight: `1px solid ${theme.palette.grey[300]}`
        }
    },
    optionContent: {
        "& .btn-delete": {
            visibility: "visible"
        },
        '& p>img': {
            maxWidth: '100%'
        }
    },
    questionActionBtn: {
        padding: theme.spacing.unit,
        minWidth: "auto",
        backgroundColor: theme.palette.grey[200],
        border: `1px solid ${theme.palette.grey[300]}`,
        color: theme.palette.text.secondary,
        borderRadius: 0
    },
    buttonAlign: {
        display: 'flex',
        alignContent: 'center',
    },

    notesBlockTitle: {
        fontSize: 20,
        fontWeight: 400,
        paddingTop: 20,
    },
    addQuestionTitle: {
        fontSize: 16,
        fontWeight: 400,
        fontFamily: 'Nunito',
    },
    tabsNotes: {
        fontSize: 16,
        fontWeight: 400,
        padding: 0,
        // marginBottom: '15px',
    },
    tabsContainer: {
        // border: 'solid 1px #E1E1E1',
        margin: '0 0 10px 0',
        padding: '20px',
        borderRadius: '5px',
        "position": "relative",
        '& label': {
            fontSize: 20,
            lineHeight: "22px",
            color: "#333333",
        },
    },
    tabsContainer2: {
        // border: 'solid 1px #E1E1E1',
        margin: '5px 0 10px 0',
        padding: '20px',
        borderRadius: '5px',
        "position": "relative",
        '& label': {
            fontSize: 20,
            lineHeight: "22px",
            color: "#333333",
        },
    },
    searchNotesinput: {
        fontSize: 14,
        fontWeight: 400,
        padding: 0,
        fontStyle: "italic",
        '& input': {
            paddingLeft: "40px",
        },
    },
    OrDivider: {
        margin: "25px 0",
        display: "block",
        position: "relative",
        textAlign: "center",
        height: "50px",
        zIndex: 0,
    },
    orText: {
        background: "#E0E6E7",
        height: "40px",
        width: "40px",
        borderRadius: "100%",
        fontStyle: "italic",
        fontSize: 14,
        color: "#989898",
        display: "inline-block",
        paddingTop: "8px",
        "position": "absolute",
        "top": "-20px",
        left: '47%',
    },
    dividerBar: {
        "position": "absolute",
        "left": 0,
        "top": "15px",
        width: "100%",
        "content": " ",
        height: "1px",
        background: "#E0E6E7",
        "z-index": "1",
    },
    textAlignCenter: {
        textAlign: "center",
    },
    perfectScrollbar: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit,
        marginTop: '40px',
        // paddingBottom: theme.spacing.unit,
        maxHeight: 'inherit',
        background: 'rgb(255, 255, 255)',
        borderRadius: 4,
        '& .ps--active-x > .ps__rail-x, .ps--active-y > .ps__rail-y': {
            opacity: 1
        },
        paddingBottom: 24
    },

    addPageMore: {
        background: '#FFF !important',
        color: '#1D7DEA !important',
        // width: '100',
        marginRight: 6,
        // border: '1px solid #1D7DEA',
        boxSizing: 'border-box',
        borderRadius: 4,
        fontWeight: 600,
        fontSize: '0.875rem',
    },
    seachQuestionText: {
        fontSize: 16,
        fontWeight: 400,
        padding: 0,
    },
    containerBorder: {

    },
    backIconRoot: {
        fill: theme.palette.text.secondary,
        fontSize: 24,
        opacity: 0.5,
        marginBottom: 3
    },
    imgSearch: {
        "position": "absolute",
        "left": "30px",
        "top": "54px",
        "z-index": "1",
    },
    ". MuiTab-root-355": {
        fontSize: "1.25rem !important",
    },
    selectedQues: {
        paddingRight: '20px',
    },
    dialogContent: {
        padding: 0,
        maxHeight: '100%',
        marginTop: 20
    },
    mandatory: {
        color: 'red',
    },
    ".MuiPrivateTabIndicator-colorPrimary-343": {
        backgroundColor: 'none !important',
    },
    ".MuiPrivateTabIndicator-root-342": {
        display: "none !important",
    },
    cardHeading: {
        fontWeight: theme.typography.fontWeightRegular,
        paddingTop: "15px",
    },
    dialogTitle: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit,
        paddingBottom: theme.spacing.unit,
        backgroundColor: 'white',
        '& > h6 > div': {
            minHeight: theme.spacing.unit * 7,
        },
        textTransform: 'capitalize',
        borderBottom: '1px solid rgb(226 226 226)',
        position: 'fixed',
        zIndex: 1001,
        top: 0,
        left: 0,
        right: 0
    },
    notesTitle: {
        // border: 'solid 1px #E1E1E1',
        margin: '5px 0 10px 0',
        // padding: '20px',
        borderRadius: '5px',
        "position": "relative",
        '& label': {
            fontSize: 16,
            lineHeight: "22px",
            color: "#333333",
            fontFamily: 'Nunito',
            display: "block",
            // paddingBottom: "20px"
        },
    },
    greyBgPanel: {
        backgroundColor: '#ccc',
        '& .MuiExpansionPanelDetails-root-321': {
            backgroundColor: "#F2F5F6 !important",
        },
    },
    cursorPointer: {
        cursor: "pointer",
      },
      link: {
        marginRight: 24,
        fontSize: 16,
        "&:hover": {
          color: "#333",
          fontWeight: 600,
        },
      },
      darkGrey: {
        color: "#999",
      },
      activeTabStyle: {
        color: "black",
        fontWeight: 600,
        display: "inline-block",
        position: "relative",
        "&::before": {
          content: "' '",
          width: "100%",
          height: 2,
          backgroundColor: "#333",
          display: "inline-block",
          position: "absolute",
          bottom: -5,
          borderRadius: 8,
        },
      },
      paddingLeft56: {
        paddingLeft: 56,
      },
      verticalSpace: {
        marginTop: "24px",
      },
      attachFileContainer: {
        background: "#FFFFFF",
        border: "1px solid #DFDFDF",
        boxSizing: "border-box",
        borderRadius: 4,
        width: '100%',        
        '& .paddingMD': {
          padding: "6px 20px 4px",
        },
        '& .buttonSubLabel': {
          padding: "13px 0 7px",
          '& p': {
            color: '#333',
            fontWeight: 700,
            fontSize: '14px',
          }
        },
        '& .attachmentIcon': {
          display: "inline-block",
          verticalAlign: "middle",
          paddingTop:8,
        },
        '& .padding30': {
            padding: '40px 0 25px', 
            border: '2px dashed #dfdfdf', 
            maxWidth: '550px',
            margin: '10px auto', 
            marginBottom: 25,
        },
        '& .uploadPanel':{
            background: '#FBFBFB',
            border: '1px solid #DCDCDC',
            borderRadius: 4,
            padding: '20px 20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 20px 20px',
        },
        '& .subjective-upload-panel':{
            minHeight: '185px',
            border:'0',
            textAlign: 'center',
            margin: '0',

        }, 
        '& .zero-margin':{
            border:'0',
            overflowX:"hidden"
        },    
       ' & .fileInfo-margin-left':{
            marginLeft: '0px'

        },        
        '& .uploadPreviewBox': {
          minHeight: 16,
          padding: "12px 0px 0px",
          position: 'relative',          
          zIndex: 9,
          //marginTop: '20px',
        '&>div:nth-child(2)':{
            height: 500,
            overflow: 'auto',
            marginTop: '42px',
        },
        '& .rpv-core__inner-page':{
            padding: '0 !important',
        },
        '& .rpv-core__page-layer':{
            width: '100% !important',
        },
        '&>div:nth-child(1)':{
            // marginTop: '20px',
        },
        '&>div:nth-of-type(2)':{
            '&>div:nth-of-type(1)':{
                '&>div:nth-of-type(1)':{
                    height: 'initial !important',
                    '&>div:nth-of-type(1)':{
                        maxHeight: '500 !important',
                    }
                }, 
            },
        },
          
        },
        '& .heading': {
          padding: '16px 20px',
          borderBottom: "solid 1px rgb(223 223 223)",
          '& p': {
            fontSize: 18,
            fontWeight: 400
          }
        }
      },
      errorText: {
        textAlign: 'center',
        color: theme.palette.error.light,
        verticalAlign: "middle",
        marginTop: "3px",
        padding: '4px 20px',
        "& svg": {
          verticalAlign: "bottom",
        },
      },
      fileLabel: {
        cursor: "pointer",
        padding: '0px 6px 0px 0px'
      },
      inputFile: {
        display: "none",
      },
      tabContainer:{
        borderBottom: '1px solid #dfdfdf',
        paddingBottom: 3,
      },
      activeTabStyles:{
          color: '#1d7dea',
          position: 'relative',
          "&::before": {
            content: "' '",
            width: "100%",
            height: 2,
            backgroundColor: "#1d7dea",
            display: "inline-block",
            position: "absolute",
            bottom: -5,
            borderRadius: 8,
      },
      '&:hover':{
          color: '#1d7dea',
      }
    },
    // PDF and Workbook Tab
    pdfWorkbook_Tab:{
        display: 'flex',
        padding: '16px 20px 0px 20px',
        '& .pwTab1':{
            border: '1px solid rgba(153, 153, 153, 0.4)',            
            fontSize: 16,
            fontWeight: 400,
            padding: '7px 20px',
            borderRadius: '4px 0 0 4px',
            cursor: 'pointer',
            marginBottom: '0px',
        },
        '& .pwTab2':{
            border: '1px solid rgba(153, 153, 153, 0.4)',            
            fontSize: 16,
            fontWeight: 400,
            padding: '7px 20px',
            borderRadius: '0 4px 4px 0',
            cursor: 'pointer',
            marginBottom: '0px',
        },
        '& .activeTab':{
            backgroundColor: '#1d7dea',
            color: '#fff',
            fontWeight: 600,
        }
    },
    createPraticeSetBlock:{
        marginBottom: 16,
    },
    errorStateBorder: {
        border: "1px solid red !important"
    },
    errorMessageColor: {
        color: "red"
    },
    marginForSubHeadingContainer:{
        marginTop: "16px"
    },
    associatedQuestion:{
        display:"flex",
        alignItems:"center",
        height:"90px"
    },
    associatedQuestionPageRange: {
        height: "41px",
        width: "170px",    },
    associatedQuestionText: {
        fontSize: "14px",
        margin: "auto 18px"

    }, subHeadingErrorMessage: {
        color: "#F21D1D",
        fontSize: '12px'
    },
    hideX:{
        overflowX:"hidden",
        padding: '5px'
    }
});

enum FilterValues {
    status = 'status',
    published = 'PUBLISHED',
    contentType = 'contentType',
    question = 'question',
    MMCQ = 8
}
enum PageKeys {
    page1 = 'page1'
}
interface StudyNotesCreateProps extends WithStyles<typeof styles> {
    history: any,
    actionType: any,
    notesData: any,
    notesData1: any,
    handleNotesData: any,
    pageSetForNotes: any,
    setConceptAndChapters: any,
    addTags: any,
    type: any,
    showMsg: any,
    subType: any,
    prevSubTypesState: any,
    setPageInContent: any,
    removeStyleInContent: any,
    tagsList: any
    pageTabState: any,
    isUploadModal: any,
    showVideo: any,
    showVideoModal: any,
    clearContentListData: Function,
    editRights: string[];
    setNotesPdfFile: Function;
    updateStatusTab:Function;
    setPractiseSetContent:Function;
}
interface StudyNotesCreateState {
    isUploadStart: boolean,
    title: string,
    pageState: any,
    componentAddCounter: any,
    componenetStoreArray: any,
    isDisabled: boolean,
    touched: any,
    deletePopUpDialogforPage: boolean,
    isAddInstruction: boolean,
    isCustomDescription: boolean,
    errorMessage: any,
    pageSetForNotes: any,
    statusTypes: any,
    deletePopUpDialog: any,
    tags: any,
    isOtherOptionsOpen: boolean;
    isFixedAttempts: boolean;
    pageArray: any,
    courses: any;
    loadingTemplates: boolean;
    templates: any;
    languages: any;
    viewDetailId: string;
    selectedTemplateId: string;
    selectedSectionId: string;
    courseName: string;
    selectQuestionDialogOpen: boolean,
    selectVideoDialogOpen: boolean,
    setConceptAndPages: any,
    preSelectedFilterContent: any,
    selectedQuestionCount: any,
    isCollaspableAllowed: any,
    mathEditor: any,
    deleteKey: any,
    searchId: any,
    questionsList: any,
    showSuggestedConcept: boolean,
    suggestedQuestions: any,
    inSectionContent: any,
    selectQuestionDialogData: {
        sectionId: string;
        subSectionId: string;
        quesCodeAllowed: number;
        noOfQuestions: number;
        replaceIndex: number;
        replaceIndexJ: number;
        content_Id: string;
        addedQuestions: any;
    };
    selectedTempQuestions: any;
    chooseLibraryKey: any,
    selectedTrackedQuestionIds: any;
    data: any;
    filledTab: any,
    filterSelectedQuestion: any,
    activeTab: string,  
    pdfFileAttachment: Attachment[];
    documentsname:string;
    pdfPageData: any;
    pdfUrl: string;
    password: string;
    pdfType: string;
    noteType:boolean;
    subHeadingSettings: any;
    errorListForSubHeadingRange: string[];
    replaceQuestion:boolean
    contentType: string;
    isTitleLoaded: boolean;
}

const initialQuestionState = {
    searchId: '',
    title: '',
    content_Id: '',
    addInstruction: '',
    passageId: '',
};
const initialTheoryState = {
    theoryDescription: '',
    isPageFull: false,
};
const initialVideoState = {
    videoURL: '',
    videoTitle: '',
    videoDescription: '',
    contentId: null,
    id: null,
}
const initialAudioState = {
    audioURL: '',
    audioTitle: '',
    audioDescription: '',
    contentId: null,
    id: null,
}
const preSelectedFilterContent: any = {
    contentMenu: "all",
    goalsDriller: {},
    contentFilterData: [{
        filterValue: FilterValues.contentType,
    isSelected: true,
        disabled: false,
        filters: [{
            filterValue: FilterValues.question,
            isSelected: true,
            disabled: false,
            filters: []
        }
        ]
    },
    {
        filterValue: FilterValues.status,
        isSelected: true,
        filters: [{
            filterValue: FilterValues.published,
            isSelected: true,
            filters: []
        }],
    }
    ]
}

class StudyNotesCreate extends Component<StudyNotesCreateProps, StudyNotesCreateState> {
    constructor(props: StudyNotesCreateProps) {
        super(props);
        // unused state should be remove further
        this.state = {
            title: this.props.notesData.title,
            pageState: { ...this.props.notesData.pageState },
            pageSetForNotes: {},
            isUploadStart: false,
            componentAddCounter: Object.keys(this.props.notesData.pageState).length - 1,
            componenetStoreArray: [1],
            inSectionContent: [...this.props.prevSubTypesState],
            isDisabled: false,
            isAddInstruction: true,
            isCustomDescription: true,
            deletePopUpDialogforPage: false,
            touched: {},
            setConceptAndPages: [],
            tags: [],
            searchId: '',
            errorMessage: {
                title: '',
            },
            statusTypes: {
                page1: this.props.prevSubTypesState[0].subType[0]
            },
            deleteKey: '',
            pageArray: [],
            questionsList: [],
            suggestedQuestions: [],
            showSuggestedConcept: false,
            loadingTemplates: false,
            isOtherOptionsOpen: false,
            isFixedAttempts: false,
            deletePopUpDialog: false,
            selectedQuestionCount: 0,
            courses: [],
            templates: [],
            languages: [],
            viewDetailId: "",
            selectedTemplateId: "",
            selectedSectionId: "",
            courseName: "",
            mathEditor: null,
            chooseLibraryKey: '',
            preSelectedFilterContent: {},
            selectQuestionDialogOpen: false,
            selectVideoDialogOpen: false,
            selectQuestionDialogData: {
                sectionId: "",
                subSectionId: "",
                quesCodeAllowed: -1,
                noOfQuestions: 0,
                replaceIndex: -1,
                replaceIndexJ: -1,
                content_Id: "",
                addedQuestions: []
            },
            selectedTempQuestions: [],
            selectedTrackedQuestionIds: {},
            data: [],
            filterSelectedQuestion: [],
            isCollaspableAllowed: {},
            filledTab: {
                page1: '',
            },
            activeTab: "Type Notes",
            pdfFileAttachment: [],
            documentsname:'',
            pdfPageData: {
                currentPage: 1,
                totalPages: 0
            },
            contentType: '',
            pdfUrl:  '',
            password: '',
            pdfType: '',
            noteType: true,
            subHeadingSettings: this.getSubHeadingList(this.props.notesData),
            errorListForSubHeadingRange:this.fillArrayWithLength(this.getSubHeadingList(this.props.notesData).length),
            isTitleLoaded: false,
            replaceQuestion:false
        }

        this.onDocumentLoad = this.onDocumentLoad.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
    }

    componentDidMount = () => {
        this.props.updateStatusTab(this.updateTabStatus);
    }


    componentDidUpdate(prevProps: Readonly<StudyNotesCreateProps>, prevState: Readonly<StudyNotesCreateState>, prevContext: any): void {
        const prevTitle = this.state.title;
        const currTitle = this.props.notesData.title;
        const shouldCallTitle = !this.state.isTitleLoaded && !prevTitle && prevTitle !== currTitle;
        shouldCallTitle && this.setTitle();
    }
    
    getSubHeadingList(notesData:any) {

        const subHeadingList = _.get(notesData,"content.subHeadingSettings",[])

        return subHeadingList.length ? subHeadingList : [this.getDefaultSubHeading()];

    }

    getNotesType = (notes: NOTES_SECTION): NOTES_TYPE => {

        if (OBJECTIVE_NOTES.includes(notes))
            return NOTES_TYPE.OBJECTIVE_NOTES;

        if (SUBJECTIVE_NOTES.includes(notes))
            return NOTES_TYPE.SUBJECTIVE_NOTES;

        return NOTES_TYPE.SIMPLE_NOTES;
    }

    isArchiveNotes = () => {
        const notesType = _.get(this.props.notesData, 'content.subType', '');
        return ARCHIVE_NOTES.includes(notesType);
    } 

    updateStateForPracticeSet() {
        this.props.setPractiseSetContent();
        this.setState({ inSectionContent: [...this.props.prevSubTypesState] })
    }

    getTitleForNotes() {
        const notesType = this.getNotesType(_.get(this.props.notesData, 'content.subType', ''));

        return notesType === NOTES_TYPE.SIMPLE_NOTES ? "Page" : "Question";
    }

    updateTabStatus = () => {
        const { notesData: { activeTab = '', pdfUrl = '', subjects = [], tags = [] } = {} } = this.props

        const notesType = this.getNotesType(_.get(this.props.notesData, 'content.subType', ''));

        switch (notesType) {
            case NOTES_TYPE.SUBJECTIVE_NOTES:
                this.updateStateForPracticeSet();
                this.setActiveTab(CREATE_NOTES_TABS.UPLOAD_PDF);
                break;
            case NOTES_TYPE.OBJECTIVE_NOTES:
                this.updateStateForPracticeSet();
                this.setActiveTab(CREATE_NOTES_TABS.TYPE_NOTES);
                break;
        }

        let pages;
        try {
            pages = JSON.parse(JSON.stringify((this.props.notesData.content || {}).pages));

        } catch { }
        let pdfType = '';
        if (pages && pages.length) {
            if (pages[0].type === 'PDF') {
                if (pages[0].subType === 'WORKBOOK') {
                    pdfType = 'WorkBook';
                } else {
                    pdfType = 'PDF Notes';
                }
            }
        }
        this.setState({ ...this.state, pdfType})
        if (subjects && subjects.length) {
            this.setConceptAndTags(1);
        }
        if (tags && tags.length) {
            this.setConceptAndTags(2);
        }
            this.setTitle();
        if(activeTab && pdfUrl) {
            let name = pdfUrl.split("/studyMaterial_")[1];
            name = name.split("_")[1]
            let attachment = [ pdfUrl]
            this.setState({ activeTab: activeTab, pdfUrl: pdfUrl, pdfFileAttachment: attachment },()=>{
                this.addUploadFileInSection();
            });
        }
    }
   addUploadFileInSection=()=>{
    const {inSectionContent,pdfFileAttachment, pdfType}=this.state;
    let copyInSectionContent = JSON.parse(JSON.stringify(inSectionContent));
    
    if(copyInSectionContent[0]){
        let uploadType:any={
                'key': "createNotes",
                'state': pdfFileAttachment.length>0?1:2,
                'title': "Upload PDF",
                'visible': true,
                pdfType
                }
                copyInSectionContent[0].subType=[uploadType];     
    }
    copyInSectionContent[0].state=pdfFileAttachment.length>0?1:2;
    this.setState({
        inSectionContent: copyInSectionContent
      },()=>{ this.props.setPageInContent([...this.state.inSectionContent])});
   }
    setTitle = () => {
        const { inSectionContent, title = '' } = this.state;
        const { notesData = {} } = this.props;
        if (title || (notesData && notesData.title)) {
            this.setState({
              title: title || notesData.title,
              isTitleLoaded: true,
            });
            let subTypes = inSectionContent[0].subType;
            let filterSubType = subTypes.filter((ele: any) => ele.state === 1);
            if (filterSubType.length === subTypes.length) {
                let copyInSectionContent = inSectionContent;
                copyInSectionContent[0] = {
                    ...copyInSectionContent[0],
                    state: 1,
                }
                this.setState({
                    inSectionContent: [
                        ...copyInSectionContent
                    ]
                }, () => {
                    this.props.setPageInContent([...this.state.inSectionContent]);
                });
            }
        }
    }

    setConceptAndTags = (location: number) => {
        setTimeout(() => {
            let setConceptAndTagsInSection = [...this.state.inSectionContent];
            setConceptAndTagsInSection[location] = {
                ...setConceptAndTagsInSection[location],
                state: 1,
            };
            this.handleSectionInContent(setConceptAndTagsInSection);
        }, 100)
    }
    
    reIntialisePages=()=>{
        const { componentAddCounter, statusTypes } = this.state;
        const { notesData: { pageState = {} } } = this.props;
        const pageLength = Object.keys(pageState);
        this.props.handleNotesData({
            pageState: {
                [`page1`]: {
                    ['question']: {
                        searchId:"",
                        title:"",
                        content_Id:"",
                        attempt:true,
                        customDescription: '',
                        addInstruction: '',
                        subHeading: '',
                        passageId: '',
                    },
                    ['theory']: {
                        theoryDescription: '',
                        subHeading: ''
                    },
                    ['video']: {
                        videoURL: '',
                        videoTitle: '',
                        contentId: null,
                        id: null,
                        videoDescription: '',
                        subHeading: ''
                    },
                    ['audio']: {
                        audioURL: '',
                        contentId: null,
                        id: null,
                        audioTitle: '',
                        audioDescription: ''
                    },
                    pageContentType: 'Theory'
                }
            }
        });
        const setStatusTypes = {
            title: `${this.getTitleForNotes()} 1`,
            previousState: 4,
            key: 'createNotes',
            state: 4,
            visible: true,
        };
        this.setState({
            statusTypes: {
                ...statusTypes,
                [`page1`]: {
                    ...setStatusTypes
                }
            }
        })
    }

    setActiveTab = (tab: string) => {
        this.setState({ activeTab: tab });
        this.props.handleNotesData({activeTab:tab});
        const {inSectionContent}=this.state;
      if(tab==='Upload PDF'){  
       this.addUploadFileInSection();
       this.reIntialisePages();
      }else{
        const copyInSectionContent = JSON.parse(JSON.stringify(inSectionContent));
        let subType:any []=_.get(copyInSectionContent,"[0].subType",[]);
        subType=[{'key': "createNotes",
            'state': 2,
            'title': `${this.getTitleForNotes()} 1` ,
            'visible': true
            }];
        copyInSectionContent[0].subType=subType;
        this.props.setNotesPdfFile([]);
        this.props.handleNotesData({pdfUrl: ''});
        this.setState({inSectionContent:copyInSectionContent,
                      pdfFileAttachment: [],
                      pdfUrl: ''},
         ()=>{ this.props.setPageInContent([...this.state.inSectionContent])});  
      }
        // this.props.setNotesPdfFile(tab)
      }

    getTitlePlaceHolder = () => {

        const subType = _.get(this.props.notesData, 'content.subType', '')
        const notesType = this.getNotesType(subType);

        let title = 'Notes';

        if (notesType !== NOTES_TYPE.SIMPLE_NOTES) {
            title = this.isArchiveNotes() ? 'Archive' : 'Practice Set'
        }

        return title;
    }

    handleTitleValidations = (title: any) => {
        const { errorMessage = {} } = this.state;
        if (this.getTitleError(title)) {
            this.setState({
                errorMessage: {
                    ...errorMessage,
                    title: `${this.getTitlePlaceHolder()} title should not be less than 5 characters`
                },
                isTitleLoaded: true,
            }, () => {
                this.props.handleNotesData({ pageError: this.state.errorMessage })
            })
        }
        else {
            this.setState({
                errorMessage: {
                    ...errorMessage,
                    title: ''
                },
                isTitleLoaded: true,
            }, () => {
                this.props.handleNotesData({ pageError: this.state.errorMessage })
            })
        }
    }

    retainMetaData = (key:any, field:any, type:any, value = null) => {
        let stateClone = JSON.parse(JSON.stringify(this.state));
        stateClone.pageState[key][type][field] = value;
        this.setState({...stateClone}, () => this.props.handleNotesData({pageState: stateClone.pageState}));
    }

    handleInputChange = (field: any) => (event: any) => {
        

        this.setState({ ...this.state, [field]: event.target.value.trimLeft() }, () => {
            const { title } = this.state;
            this.handleTitleValidations(title);
            this.props.handleNotesData({
                [field]: title
            });
            const { inSectionContent } = this.state;
            if (!title) {
                let copyInSectionContent = inSectionContent;
                copyInSectionContent[0] = {
                    ...copyInSectionContent[0],
                    state: 3,
                }
                this.setState({
                    inSectionContent: [
                        ...copyInSectionContent
                    ]
                }, () => {
                    this.props.setPageInContent([...this.state.inSectionContent]);
                });
            }
            else {
                let subTypes = inSectionContent[0].subType;
                let filterSubType = subTypes.filter((ele: any) => ele.state === 1);
                if (filterSubType.length === subTypes.length) {
                    let copyInSectionContent = inSectionContent;
                    copyInSectionContent[0] = {
                        ...copyInSectionContent[0],
                        state: this.getTitleError(title) ? 2 : 1,
                    }
                    this.setState({
                        inSectionContent: [
                            ...copyInSectionContent
                        ]
                    }, () => {

                        this.props.setPageInContent([...this.state.inSectionContent]);
                    });

                }
            }
        });
    };

    getDefaultSubHeading() {
        return {
            subHeading: '',
            pageRange: {
                start: 0,
                end: 0
            }
        }
    }

    addNewSubHeading = () => {

        const subHeadingList = JSON.parse(JSON.stringify(this.state.subHeadingSettings));
        subHeadingList.push(this.getDefaultSubHeading());
        this.handleSubHeadingChange(subHeadingList);
    }

    handleSubHeadingChange = (subHeadingSettings: any[]) => {

        this.setState({ subHeadingSettings });
        this.props.handleNotesData({ subHeadingSettings });
        this.checkForSubHeadingRange(subHeadingSettings)
    }

    getSaprator(str: string) {

        return (str.length ? ' ,' : '') + 'Question '
    }

    fillArrayWithLength(length: number) {
        return Array(length).fill('')
    }

    checkForSubHeadingRange = (subHeadingSettings: any[] = []) => {

        const subHeadingLength = subHeadingSettings.length;

        const maxRange = subHeadingSettings.reduce((acc: number, { pageRange: { start, end } }: any) => {
            const range = Math.max(start, end);
            return Math.max(range, acc);

        }, 0);

        const questionList: number[][] = new Array(maxRange + 1);

        for (let i = 0; i <= maxRange; i++)
            questionList[i] = [];

        subHeadingSettings.forEach(({ pageRange: { start, end } }: any, index: number) => {

            for (let i = Math.max(start, 1); i <= Math.max(start, end); i++)
                questionList[i].push(index);
        })

        const rangeOverlap: number[][] = Array(subHeadingLength);

        for (let i = 0; i < subHeadingLength; i++)
            rangeOverlap[i] = [];

        questionList.forEach((questionNumber: number[], questionIndex) => {
            if (questionNumber.length == 1)
                return;

            questionNumber.forEach((headingIndex: number) => rangeOverlap[headingIndex].push(questionIndex));
        })

        rangeOverlap.forEach(rangeList => rangeList.sort());

        const errorList = this.fillArrayWithLength(subHeadingLength);

        for (let i = 0; i < rangeOverlap.length; i++) {
            rangeOverlap[i].sort((a: number, b: number) => a - b);

            let f = rangeOverlap[i][0];
            rangeOverlap[i].push(-1);

            for (let j = 0; j < rangeOverlap[i].length - 1; j++) {

                if (rangeOverlap[i][j] + 1 != rangeOverlap[i][j + 1]) {

                    if (f == rangeOverlap[i][j])
                        errorList[i] += this.getSaprator(errorList[i]) + f.toString();
                    else errorList[i] += this.getSaprator(errorList[i]) + f.toString() + ' to ' + rangeOverlap[i][j].toString();

                    f = rangeOverlap[i][j + 1];
                }
            }
        }

        subHeadingSettings.forEach(({ pageRange: { start, end } }: any, index: number) => {
            const range = Math.min(start, end);

            if (range == 0 || start <= end)
                return;

            errorList[index] = 'End Question number should be greater than equal to Start Question number';
        })

        this.setState({ errorListForSubHeadingRange: errorList });
    }

    getPageNumber = (key: any): any => {
        const extractNumber = key.replace(/^\D+/g, '');
        return extractNumber;
    }
    handleAddPageForTheory = (newPageState: any, key: any) => {
        this.props.handleNotesData({
            pageState: newPageState
        });
        const newKey = `page${Number(this.getPageNumber(key)) + 1}`;
        const { statusTypes } = this.state;
        this.setState({
            statusTypes: {
                ...statusTypes,
                [newKey]: {
                    ...statusTypes[newKey],
                    title: `${this.getTitleForNotes()} ${Number(this.getPageNumber(key)) + 1}`,
                    key: 'createNotes',
                    state: 1,
                    visible: true,
                }
            },
        }, () => {
            const { statusTypes: stTypes } = this.state;
            const pageString = Object.keys(newPageState);
            let tempArrayForStatusData: any = [];
            for (let i = 1; i <= Object.keys(stTypes).length; i++) {
                if (`page${i}` !== key) {
                    if (pageString.includes(`page${i}`)) {
                        tempArrayForStatusData.push(stTypes[`page${i}`])
                    }
                }
                else {
                    tempArrayForStatusData.push(stTypes[key]);
                }
            }
            const { inSectionContent } = this.state
            let copyInSectionContent = inSectionContent;
            copyInSectionContent[0] = {
                ...copyInSectionContent[0],
                subType: [...tempArrayForStatusData],
                state: 3,
            }
            this.setState({
                inSectionContent: [
                    ...copyInSectionContent
                ]
            }, () => {
                this.props.setPageInContent([...this.state.inSectionContent])
            });
            // this.props.setPageInContent([...tempArrayForStatusData]);
        })
    }

    handleFilledData = (key: any, type: any) => {
        const { notesData: { pageState = {} } = {} } = this.props;
        let filledKeys: any = [];
        let counter = 0;
        let items = new Set();
        const { filledTab } = this.state;
        Object.keys(pageState[key][type]).map((item: any) => {
            if (item !== 'attempt') {
                // _.isEmpty(pageState[key][type][item].replace(/(&nbsp;|<([^>]+)>)/ig, '')) ? filledKeys.splice(item, 1) : filledKeys.push(item);
                if (pageState[key][type][item] && typeof (pageState[key][type][item]) === 'string' && pageState[key][type][item].replace(/(&nbsp;|<([^>]+)>)/ig, '')) {
                    counter = counter + 1;
                    items.add(item);
                }
                if (counter === 0) {
                    filledKeys = [];
                } else {
                    filledKeys = Array.from(items);
                }

            }
        });
        filledKeys.length > 0 ? this.setState({
            filledTab: {
                ...filledTab,
                [key]: type
            }
        }) : this.setState({
            filledTab: {
                ...filledTab,
                [key]: ''
            }
        })
    }
    handleSectionInContent = (copyInSectionContent: any) => {
        this.setState({
            inSectionContent: [
                ...copyInSectionContent
            ]
        }, () => {
            this.props.setPageInContent([...this.state.inSectionContent])
        });
    }
    handleStatusTypes = (state: number, pageState: any, key: any) => {
        const { statusTypes } = this.state;
        if (state === 1) {
            this.setState({
                statusTypes: {
                    ...statusTypes,
                    [key]: {
                        ...statusTypes[key],
                        title: `${this.getTitleForNotes()} ${this.getPageNumber(key)}`,
                        state: state,
                        key: 'createNotes',
                        visible: true,
                    }
                },
            }, () => {
                const { statusTypes: stTypes } = this.state;
                const pageString = Object.keys(pageState);
                let tempArrayForStatusData = [];
                for (let i = 1; i <= Object.keys(stTypes).length; i++) {
                    if (`page${i}` !== key) {
                        if (pageString.includes(`page${i}`))
                            tempArrayForStatusData.push(stTypes[`page${i}`])
                    }
                    else {
                        tempArrayForStatusData.push(stTypes[key])
                    }
                }

                const { inSectionContent } = this.state
                let copyInSectionContent = inSectionContent;
                copyInSectionContent[0] = {
                    ...copyInSectionContent[0],
                    subType: [...tempArrayForStatusData],
                    state: 1,
                    visible: true,
                }
                this.handleSectionInContent(copyInSectionContent);
                const { subType } = inSectionContent[0];
                let pageStateKeys = Object.keys(pageState);
                let newSubType = Object.keys(stTypes).filter((element) => pageStateKeys.filter((ele) => ele === element))
                let newFilteredSubType: any = [];
                newSubType.forEach((element) => {
                    newFilteredSubType.push(stTypes[element]);
                })
                let filterSubTypes = newFilteredSubType.filter((ele: any) => ele.state === 1 || subType.length === 1);
                if (filterSubTypes.length === subType.length && this.state.title) {
                    copyInSectionContent[0] = {
                        ...copyInSectionContent[0],
                        subType: [...tempArrayForStatusData],
                        state: 1,
                        visible: true,
                    }
                } else {
                    copyInSectionContent[0] = {
                        ...copyInSectionContent[0],
                        subType: [...tempArrayForStatusData],
                        state: 3,
                        visible: true,
                    }
                }
                this.handleSectionInContent(copyInSectionContent);
            })

        } else {
            this.setState({
                statusTypes: {
                    ...statusTypes,
                    [key]: {
                        ...statusTypes[key],
                        title: `${this.getTitleForNotes()} ${this.getPageNumber(key)}`,
                        key: 'createNotes',
                        state: state,
                        visible: true,
                    }
                },
            }, () => {
                const { statusTypes: stTypes } = this.state;
                const pageString = Object.keys(stTypes);
                let tempArrayForStatusData: any = [];
                for (let i = 1; i <= Object.keys(stTypes).length; i++) {
                    if (`page${i}` !== key) {
                        if (pageString.includes(`page${i}`)) {
                            tempArrayForStatusData.push(stTypes[`page${i}`])
                        }
                    }
                    else {
                        tempArrayForStatusData.push(stTypes[key]);
                    }
                }
                const { inSectionContent } = this.state
                let copyInSectionContent = inSectionContent;
                copyInSectionContent[0] = {
                    ...copyInSectionContent[0],
                    subType: [...tempArrayForStatusData],
                    state: 3,
                }
                this.handleSectionInContent(copyInSectionContent);
            });
        }

    }

    checkAllPageStateKeys = (type: any, key: any, TotalNoOfFields: number) => {
        let countAllFieldsData = 0;
        const { pageState: ps = {} } = this.props.notesData;
        Object.keys(ps[key][type]).map((keys: any) => {
            const notRequiredKeys = ['attempt', 'contentId', 'id', 'addInstruction', 'subHeading', 'passageId'];
            if (ps[key][type][keys] && typeof (ps[key][type][keys]) === 'string' && !notRequiredKeys.includes(keys) && ps[key][type][keys].replace(/(&nbsp;|<([^>]+)>)/ig, '')) {
                countAllFieldsData = countAllFieldsData + 1;
            }
            if (type === 'question') {
                if (!ps[key][type][keys] && keys === 'title') {
                    countAllFieldsData = countAllFieldsData + 1;
                }
            }
        });
        if (countAllFieldsData === TotalNoOfFields) {
            
            this.handleStatusTypes(1, ps, key);
        }
        else {
            
            this.handleStatusTypes(2, ps, key);
        }

    }
    handlePageState = (key: any, field: any, type: any) => (event: any) => {
        const { notesData: { pageState = {} } = {} } = this.props;
        const { notesData: { subjects = [], tags = [] } = {} } = this.props;
        if (subjects && subjects.length) {
            let subjectMapping = [...this.state.inSectionContent];
            subjectMapping[1] = {
                ...subjectMapping[1],
                state: 1,
            }
            this.handleSectionInContent(subjectMapping);
        }
        if (tags && tags.length) {
            let tagsMapping = [...this.state.inSectionContent];
            tagsMapping[2] = {
                ...tagsMapping[2],
                state: 1,
            }
            this.handleSectionInContent(tagsMapping);
        }
        if (type === 'question') {
            this.props.handleNotesData({
                pageState: {
                    ...pageState,
                    [key]: {
                        ...pageState[key],
                        [type]: {
                            ...pageState[key][type],
                            [field]: ((event || {}).target || {}).value || ''
                        },
                        ['theory']: {
                            ...pageState[key]['theory'],
                            ...initialTheoryState
                        },
                        ['video']: {
                            ...pageState[key]['video'],
                            ...initialVideoState
                        },
                        ['audio']: {
                            ...pageState[key]['audio'],
                            ...initialAudioState
                        },
                        pageContentType: 'Question'
                    }
                },
            });
            // this.checkAllPageStateKeys(type, key, 4);
        }
        if (type === 'theory') {
            let text = ((event || {}).target || {}).value || '';
            this.props.handleNotesData({
                pageState: {
                    ...pageState,
                    [key]: {
                        ...pageState[key],
                        [type]: {
                            ...pageState[key][type],
                            [field]: ((event || {}).target || {}).value || '',
                        },
                        ['question']: {
                            ...pageState[key]['question'],
                            ...initialQuestionState
                        },
                        ['video']: {
                            ...pageState[key]['video'],
                            ...initialVideoState
                        },
                        ['audio']: {
                            ...pageState[key]['audio'],
                            ...initialAudioState
                        },
                        pageContentType: 'Theory'
                    }
                }
            });
            this.checkAllPageStateKeys(type, key, 1);
        }
        if (type === 'video') {
            this.props.handleNotesData({
                pageState: {
                    ...pageState,
                    [key]: {
                        ...pageState[key],
                        [type]: {
                            ...pageState[key][type],
                            [field]: field === 'videoURL' ? event : (((event || {}).target || {}).value || '')
                        },
                        ['theory']: {
                            ...pageState[key]['theory'],
                            ...initialTheoryState
                        },
                        ['question']: {
                            ...pageState[key]['question'],
                            ...initialQuestionState
                        },
                        ['audio']: {
                            ...pageState[key]['audio'],
                            ...initialVideoState
                        },
                        pageContentType: 'Video',
                    },
                }
            });
            
            this.checkAllPageStateKeys(type, key, 3);
        }
        if (type === 'audio') {
            this.props.handleNotesData({
                pageState: {
                    ...pageState,
                    [key]: {
                        ...pageState[key],
                        [type]: {
                            ...pageState[key][type],
                            [field]: field === 'videoURL' ? event : (((event || {}).target || {}).value || '')
                        },
                        ['theory']: {
                            ...pageState[key]['theory'],
                            ...initialTheoryState
                        },
                        ['question']: {
                            ...pageState[key]['question'],
                            ...initialQuestionState
                        },
                        pageContentType: 'Audio',
                    },
                }
            });
            
            this.checkAllPageStateKeys(type, key, 3);
        }
        // if(field === 'subHeading'){
        //     this.retainMetaData(key, field, type, event.target.value);
        // }
        this.handleFilledData(key, type);
    };

    updateCustomKeys = (key: any, type: any, changes: any) => {
        const { notesData: { pageState = {} } = {} } = this.props;

        let updatedPageState = JSON.parse(JSON.stringify(pageState))

        Object.keys(changes).forEach(element => {
            const keyValue = changes[element];
            updatedPageState[key][type][element] = keyValue;
        });

        this.props.handleNotesData({ pageState: updatedPageState });
    }

    saveQuestionsList = () => {
        contentService.list({ contentFilterData: preSelectedFilterContent.contentFilterData }, 1, 1000).then((result: any) => {
            if (result && result.length) {
                this.setState({
                    questionsList: result
                });
            }
        })
    }

    handleSuggestedQuestionClick = (pageNameKey: any, selectedQuestion: any) => (event: any) => {
        let { pageState } = this.props.notesData;
        let newPageState = { ...pageState };
        const newQuestion = {
            ...initialQuestionState,
            title: selectedQuestion.title,
            content_Id: selectedQuestion.content_Id,
            searchId: selectedQuestion.contentId,
            passageId: selectedQuestion.passageId
        }
        newPageState = {
            ...newPageState,
            [pageNameKey]: {
                ...newPageState[pageNameKey],
                ['question']: {
                    ...newPageState[pageNameKey]['question'],
                    ...newQuestion,
                },
                pageContentType: 'Question'
            },
        }
        this.props.handleNotesData({
            pageState: newPageState,
        });
        this.setState({
            showSuggestedConcept: false,
            suggestedQuestions: []
        })
    }
    closeSuggestedQuestions = () => {
        const { showSuggestedConcept } = this.state;
        if (showSuggestedConcept) {
            setTimeout(() => this.setState({ showSuggestedConcept: false, suggestedQuestions: [] }), 200)
        }
    }
    handleSearchFocus = () => {
        this.setState({ showSuggestedConcept: true })
    }
    handleSearchId = (key: any, field: any) => async (event: any) => {
        let value = event.target.value;
        const { notesData: { pageState = {} } = {} } = this.props;
        const { questionsList } = this.state;
        let newQuestionList = [...questionsList];
        const existingQuestions = Object.keys(pageState).map((question: any) => pageState[question].question_Id);
        newQuestionList = _.filter(questionsList, (question: any) => !(existingQuestions.includes(question.contentId)));
        const filteredQuestions = _.filter(newQuestionList, (question) => (question.contentId.includes(value.toUpperCase()) && !existingQuestions.includes(value.toUpperCase())));
        this.setState({ suggestedQuestions: filteredQuestions })
        this.props.handleNotesData({
            pageState: {
                ...pageState,
                [key]: {
                    ...pageState[key],
                    ['question']: {
                        ...pageState[key]['question'],
                        [field]: event.target.value,
                    }

                }
            }
        });
        setTimeout(() => this.handleFilledData(key, 'question'), 200)
    }

    isError = (fields: any) => {
        const { errorMessage } = this.state;
        if (errorMessage[fields]) {
            return true;
        }
        return false;
    }


    getTitleError(title: string): boolean {
        return title.length < 5;
    }

    handleAddPage = (): void => {
        const { componentAddCounter, statusTypes } = this.state;
        const { notesData: { pageState = {} } } = this.props;
        const pageLength = Object.keys(pageState);
        this.props.handleNotesData({
            pageState: {
                ...pageState,
                [`page${pageLength.length + 1}`]: {
                    ...pageState[`page${pageLength.length + 1}`],
                    ['question']: {
                        ...pageState[`page${pageLength.length + 1}`],
                        searchId: '',
                        customDescription: '',
                        addInstruction: ''
                    },
                    ['theory']: {
                        ...pageState[`page${pageLength.length + 1}`],
                        theoryDescription: ''
                    },
                    ['video']: {
                        ...pageState[`page${pageLength.length + 1}`],
                        videoURL: '',
                        videoTitle: '',
                        videoDescription: ''
                    },
                    ['audio']: {
                        ...pageState[`page${pageLength.length + 1}`],
                        videoURL: '',
                        videoTitle: '',
                        videoDescription: ''
                    },
                    pageContentType: 'Theory'
                }
            }
        });
        const setStatusTypes = {
            title: `${this.getTitleForNotes()} ${pageLength.length + 1}`,
            previousState: 4,
            key: 'createNotes',
            state: 4,
            visible: true,
        };
        this.setState({
            statusTypes: {
                ...statusTypes,
                [`page${pageLength.length + 1}`]: {
                    ...setStatusTypes
                }
            }
        }, () => {
            const { statusTypes: sTypes } = this.state;
            let rest: any = [];
            for (let i = 1; i <= pageLength.length; i++) {
                rest.push(sTypes[`page${i}`]);
            }
            const testData = sTypes[`page${pageLength.length + 1}`];
            const { inSectionContent } = this.state
            let newArray = inSectionContent;
            newArray[0] = {
                ...newArray[0],
                subType: [...rest, testData],
                state: 3,
            }
            this.setState({
                inSectionContent: [
                    ...newArray
                ]
            }, () => {
                this.props.setPageInContent([...this.state.inSectionContent])
                this.handleFilledData(`page${pageLength.length + 1}`, 'theory');
            });
            // this.props.setPageInContent([...rest, testData]);
        })
    }

    handleDeletePage = (key: any): void => {
        let { pageState = {} } = this.props.notesData;
        const pageKeysLength = Object.keys(pageState);
        pageKeysLength.pop();
        const newArr = pageKeysLength.map((element: any, index: any): any => {
            return index + 1;
        });
        const { chooseLibraryKey } = this.state;
        if (key === chooseLibraryKey) {
            const indexValue = Object.keys(pageState).indexOf(chooseLibraryKey);
            let newKey = '';
            if (indexValue === Object.keys(pageState).length - 1) {
                newKey = Object.keys(pageState)[indexValue - 1];
            }
            this.setState({
                chooseLibraryKey: newKey,
            })
        }
        const tempPageStateArray = { ...pageState };
        delete tempPageStateArray[key];
        let newPageState: any = {};
        Object.values(tempPageStateArray).forEach((pageStateValue, index) => {
            newPageState = {...newPageState, [`page${index + 1}`]: pageStateValue};
        })
        let tempArr: any = [];
        const { statusTypes: sTypes } = this.state;
        let newStatusTypes: any = {};
        let pageIndex = 1;
        Object.keys(sTypes).forEach(statusKey => {
            if(statusKey === key) return;
            let pageStatus = sTypes[statusKey];
            pageStatus = {...pageStatus, title: `${this.getTitleForNotes()} ${pageIndex}`};
            newStatusTypes[`page${pageIndex++}`] = pageStatus;
        });
        Object.values(newStatusTypes).forEach(value => {
            tempArr.push(value);
        })
        // const updatedCounter = updater("DECREMENT", componentAddCounter)
        this.props.handleNotesData({
            pageState: newPageState,
        })

        const { inSectionContent } = this.state
        let newArray = inSectionContent;
        let filterNewPages = tempArr.filter((ele: any) => ele && ele.state === 1);
        this.setState({
            statusTypes: newStatusTypes
        })
        if (filterNewPages.length === tempArr.length && this.state.title) {
            newArray[0] = {
                ...newArray[0],
                subType: [...tempArr],
                state: 1,
            }
        } else {
            newArray[0] = {
                ...newArray[0],
                subType: [...tempArr],
                state: 3,
            }

        }
        this.setState({
            inSectionContent: [
                ...newArray,
            ]
        }, () => {
            this.props.setPageInContent([...this.state.inSectionContent]);
            if (pageState[key]['question'] && pageState[key]['question']['searchId']) {
                this.removeSelectedQuestion(pageState[key]['question']['searchId']);
            }
        });
        // this.props.removeStyleInContent(tempArr);
    }

    removeSelectedQuestion = (searchId: any) => {
        const { filterSelectedQuestion } = this.state;
        let newFilteredSelectedQuestion = filterSelectedQuestion.filter((ele: any) => ele.contentId !== searchId);
        this.setState({
            filterSelectedQuestion: newFilteredSelectedQuestion,
        })
    }

    addQuestionToList(question:any){

        const {selectedTempQuestions}=this.state;
        
        //case for passage type question to explicitly get the first passage question details to be displayed
        if (question.passageData && question.passageData.length > 1){
            question.title = question.passageData[0].title;
            question.contentId = question.passageData[0].contentId;
            question.content_Id = question.passageData[0].id;
        }
        const contentSubTypeCode = (question && +question.contentSubTypeCode) || 9; // 9 is Sub Type Code for Videos
        const questionTypeAllowed = question && isQuestionTypeAllowed(contentSubTypeCode); 
        if(questionTypeAllowed) {
            
             
            selectedTempQuestions.push(question);
           
            this.setState({ selectedTempQuestions });
        } else {
            if(question && !questionTypeAllowed){
                
                this.props.showMsg(
                    `${getQuestionType(question.contentSubTypeCode.toString())} not allowed in study material`,
                    "error"
                );
            }
        }
    }

    handleContentSelect = (selectedQuestions: any[]) => {
        selectedQuestions = this.filterDuplicatePassage(selectedQuestions);

        this.setState({ selectedTempQuestions: [], selectedQuestionCount: 0 }, () => {

            const selectedTempQuestions:any[] =[]

            selectedQuestions.forEach((question:any) => {

        
                //case for passage type question to explicitly get the first passage question details to be displayed
                if (question.passageData && question.passageData.length > 1){
                    question.title = question.passageData[0].title;
                    question.contentId = question.passageData[0].contentId;
                    question.content_Id = question.passageData[0].id;
                }
                const contentSubTypeCode = (question && +question.contentSubTypeCode) || 9; // 9 is Sub Type Code for Videos
                const questionTypeAllowed = question && isQuestionTypeAllowed(contentSubTypeCode); 
                if(questionTypeAllowed) {
                        
                    selectedTempQuestions.push(question);
                   
                    
                } else {
                    if(question && !questionTypeAllowed){
                        
                        this.props.showMsg(
                            `${getQuestionType(question.contentSubTypeCode.toString())} not allowed in study material`,
                            "error"
                        );
                    }
                }
            })

            this.setState({ selectedTempQuestions,selectedQuestionCount: selectedTempQuestions.length  });

        });
    }
    
    filterDuplicatePassage(contentList: any[]): any[] {
        const passageSet = new Set<string>();
        contentList = contentList.filter((passage: any) => {
            const { passageId = '' } = passage;
            if (passageId && !passageSet.has(passageId)) {
                passageSet.add(passageId);
                return true;
            }
            return !passageId;
        });
        return contentList;
    }

    handleContentSelectAll = (selectedQuestions: any) => {
        
        this.handleContentSelect(selectedQuestions)
        
    }
    handleCheckContentExist = (content_Id: string) => {
        const { selectedTrackedQuestionIds, selectQuestionDialogData } = this.state
        const { subSectionId: selectedSubSectionId, content_Id: selectedContentId, addedQuestions, quesCodeAllowed: selectedQuestCode, replaceIndex } = selectQuestionDialogData
        const addedContent_Ids: any = new Set(addedQuestions.map((content: any) => content.content_Id))
        addedContent_Ids.delete(selectedContentId)
        const key = content_Id
        let isContentExist = false;
        if (selectedTrackedQuestionIds.hasOwnProperty(key)) {
            const quesCodeAllowed = selectedTrackedQuestionIds[key].quesCodeAllowed
            const subSectionId = selectedTrackedQuestionIds[key].subSectionId
            if (replaceIndex !== -1) {
                if (content_Id !== selectedContentId && addedContent_Ids.has(content_Id)) {
                    isContentExist = true
                }
            } else {
                if (selectedQuestCode == quesCodeAllowed) {
                    if (selectedSubSectionId !== subSectionId) {
                        isContentExist = true
                    }
                }
            }

        }
        return isContentExist
    }

    handleBackToTestpaperClick = (evt: any) => {

        this.setState({ selectQuestionDialogOpen: false, selectVideoDialogOpen: false });
        this.props.clearContentListData();
    }
    handleTrackSelectedQuestionIds(selectedQuestions: any) {
        const { selectedTrackedQuestionIds, selectQuestionDialogData } = this.state;
        const { quesCodeAllowed, subSectionId } = selectQuestionDialogData
        selectedQuestions.forEach((question: any) => {
            const key = question.content_Id
            if (!selectedTrackedQuestionIds.hasOwnProperty(key)) {
                selectedTrackedQuestionIds[key] = {
                    quesCodeAllowed,
                    subSectionId,
                    content_Id: question.content_Id
                }
            }
        });
        this.setState({ selectedTrackedQuestionIds });
    }

    handleChooseQuestionFromLibrary = (keyName: any) => {
        this.setState({ replaceQuestion: false });
        this.handleChooseFromLibrary(keyName);
    }

    handleReplaceQuestion = (keyName: any) => {
        this.setState({ replaceQuestion: true });
        // this.handleDeleteQuestions(keyName);
        this.handleChooseFromLibrary(keyName);

    }

    handleReplaceVideo = (keyName: any) => {
        this.handleDeleteVideo(keyName);
        this.handleChooseFromVideoLibrary(keyName);
    }

    getNumberFromString(string: string) {
        const numberList = string.match(/\d+/);

        return numberList ? Number.parseInt(numberList[0]) : 0;
    }


    handleAddContentClick = () => {
        let { selectedTempQuestions = [], chooseLibraryKey, data } = this.state;
        const { pageState = {} } = this.props.notesData;
        let newPageState = {...pageState};

        const selectedQuestionLength = selectedTempQuestions.length ? selectedTempQuestions.length - 1 : 0;

        const pages = Object.keys(pageState);
        const currentPage = this.getNumberFromString(chooseLibraryKey);


        pages.forEach(page => {

            const pageNumber = this.getNumberFromString(page);

            if (currentPage >= pageNumber)
                return;

            const newPageNumber = pageNumber + selectedQuestionLength;

            newPageState[`page${(newPageNumber)}`] = pageState[page];

        })

        selectedTempQuestions.forEach((question: any, index: number) => {

            const newPageNumber = currentPage + index;

            newPageState[`page${newPageNumber}`] = {
                ['question']: {
                    searchId: question.contentId,
                    title: question.title,
                    content_Id: question.content_Id,
                    subHeading: '',
                    passageId: question.passageId
                },
                pageContentType: 'Question'
            }
        })


        const {statusTypes} = this.state;
        let newStatusType:any = {};
        Object.keys(newPageState).forEach(key => {
            newStatusType = {
                ...newStatusType,
                [key]: {
                    title: `${this.getTitleForNotes()} ${this.getPageNumber(key)}`,
                    state: 1,
                    key: 'createNotes',
                    visible: true,
                }
            }
        });
        for(let i = 1; i < currentPage; i++) {
            newStatusType[`page${i}`].state = statusTypes[`page${i}`].state;
        }
        for(let i  = currentPage + 1; i < Object.keys(statusTypes).length ; i++) {
            newStatusType[`page${i + selectedQuestionLength}`].state = statusTypes[`page${i}`].state;
        }
        this.setState({
            statusTypes: newStatusType
        }, ()=> {
            this.handleStatusTypes(1, newPageState, chooseLibraryKey);
        })


        this.props.handleNotesData({ pageState: newPageState });
        this.handleFilterSelectedQuestion(selectedTempQuestions);
        this.setState({
            data: data,
            selectQuestionDialogOpen: false,
            selectedTempQuestions: [],
        }, () => {

            for (let i = currentPage; i <= Object.keys(newPageState).length; i++) {
                this.handleFilledData(`page${i}`, 'question');
            }

        });
        this.props.clearContentListData();
    };

    handleFilterSelectedQuestion = (selectedTempQuestions: any) => {
        if(!selectedTempQuestions) return;
        selectedTempQuestions = selectedTempQuestions.length ? selectedTempQuestions : [selectedTempQuestions];
        this.setState({
            filterSelectedQuestion: [...this.state.filterSelectedQuestion, ...selectedTempQuestions],
        })
    }

    handleAddContentVideoClick = () => {
        // Note: use selectedTempQuestions.title/name for title after fetching
        let { selectedTempQuestions, chooseLibraryKey, data } = this.state;
        const { pageState = {} } = this.props.notesData;
        let copyPageState = { ...pageState };
        selectedTempQuestions = selectedTempQuestions.length ? selectedTempQuestions[0] : selectedTempQuestions;
        var videoUrl = selectedTempQuestions.videoUrl || selectedTempQuestions.audioUrl;
        const contentType = this.state.contentType
        
        if (videoUrl && videoUrl.length) {
            videoServices.getHlsUrl(videoUrl).then((response) => {
                // videoUrl = response;
                if (contentType === 'audios') {

                    copyPageState = {
                        ...copyPageState,
                        [chooseLibraryKey]: {
                            ...copyPageState[chooseLibraryKey],
                            ['audio']: {
                                contentId: selectedTempQuestions.contentId,
                                id: selectedTempQuestions._id.substring(0, 24),
                                videoURL: response,
                                videoTitle: selectedTempQuestions.title,
                                videoDescription: selectedTempQuestions.description,
                                subHeading: this.props.notesData.pageState[chooseLibraryKey].audio.subHeading
                            },
                            pageContentType: 'Audio'
                        }
                    }
                } else {

                    copyPageState = {
                        ...copyPageState,
                        [chooseLibraryKey]: {
                            ...copyPageState[chooseLibraryKey],
                            ['video']: {
                                contentId: selectedTempQuestions.contentId,
                                id: selectedTempQuestions._id.substring(0, 24),
                                videoURL: response,
                                videoTitle: selectedTempQuestions.title,
                                videoDescription: selectedTempQuestions.description,
                                subHeading: this.props.notesData.pageState[chooseLibraryKey].video.subHeading
                            },
                            pageContentType: 'Video'
                        }
                    }
                }
                
                this.props.handleNotesData({ pageState: { ...copyPageState } });
                this.setState({
                    data: data,
                    selectVideoDialogOpen: false,
                    selectedTempQuestions: [],
                });
                this.props.clearContentListData();

            }).catch(() => {
                this.props.showMsg('Invalid url', 'error');
            })
        } else {
            this.props.showMsg('Invalid url', 'error');
        }


    };
    handleAddContentAudioClick = () => {
        // Note: use selectedTempQuestions.title/name for title after fetching
        let { selectedTempQuestions, chooseLibraryKey, data } = this.state;
        const { pageState = {} } = this.props.notesData;
        let copyPageState = { ...pageState };
        var audioUrl = selectedTempQuestions.audioUrl;
        
        if (audioUrl && audioUrl.length) {
            videoServices.getHlsUrl(audioUrl).then((response) => {
                // videoUrl = response;
                copyPageState = {
                    ...copyPageState,
                    [chooseLibraryKey]: {
                        ...copyPageState[chooseLibraryKey],
                        ['audio']: {
                            audioUrl: response,
                            audioTitle: selectedTempQuestions.title,
                            audioDescription: selectedTempQuestions.description,
                        },
                        pageContentType: 'Audio'
                    }
                }
                
                this.props.handleNotesData({ pageState: { ...copyPageState } });
                this.setState({
                    data: data,
                    selectVideoDialogOpen: false,
                    selectedTempQuestions: [],
                });
                this.props.clearContentListData();

            }).catch(() => {
                this.props.showMsg('Invalid url', 'error');
            })
        } else {
            this.props.showMsg('Invalid url', 'error');
        }
    };


    handleDeleteQuestions = (deleteId: any) => {
        const { pageState } = this.props.notesData;
        const { inSectionContent, statusTypes } = this.state;
        this.props.handleNotesData({
            pageState: {
                ...pageState,
                [deleteId]: {
                    ...pageState[deleteId],
                    ['question']: {
                        ...pageState[deleteId]['question'],
                        ...initialQuestionState,
                    }
                }
            }
        });
        this.setState({
            statusTypes: {
                ...statusTypes,
                [deleteId]: {
                    ...statusTypes[deleteId],
                    title: `${this.getTitleForNotes()} ${this.getPageNumber(deleteId)}`,
                    key: 'createNotes',
                    state: 3,
                    visible: true,
                }
            },
        }, () => {
            const { statusTypes: stTypes } = this.state;
            const pageString = Object.keys(stTypes);
            let tempArrayForStatusData: any = [];
            for (let i = 1; i <= Object.keys(stTypes).length; i++) {
                if (`page${i}` !== deleteId) {
                    if (pageString.includes(`page${i}`)) {
                        tempArrayForStatusData.push(stTypes[`page${i}`])
                    }
                }
                else {
                    tempArrayForStatusData.push(stTypes[deleteId]);
                }
            }
            let copyInSectionContent = inSectionContent;
            copyInSectionContent[0] = {
                ...copyInSectionContent[0],
                subType: [...tempArrayForStatusData],
                state: 3,
            }
            this.setState({
                inSectionContent: [
                    ...copyInSectionContent
                ]
            }, () => {
                this.props.setPageInContent([...this.state.inSectionContent]);
                this.handleFilledData(deleteId, 'question');
                if (pageState[deleteId]['question'] && pageState[deleteId]['question']['searchId']) {
                    this.removeSelectedQuestion(pageState[deleteId]['question']['searchId']);
                }
            });
        });
        // this.handleFilledData(deleteId, 'question');
    }

    handleDeleteVideo = (deleteId: any, toDeleteAudio?: boolean) => {
        const { pageState } = this.props.notesData;
        const { inSectionContent, statusTypes } = this.state;
        if (toDeleteAudio){

            this.props.handleNotesData({
                pageState: {
                    ...pageState,
                    [deleteId]: {
                        ...pageState[deleteId],
                        ['audio']: {
                            ...pageState[deleteId]['audio'],
                            ...initialVideoState,
                        }
                    }
                }
            });
        } else {

            this.props.handleNotesData({
                pageState: {
                    ...pageState,
                    [deleteId]: {
                        ...pageState[deleteId],
                        ['video']: {
                            ...pageState[deleteId]['video'],
                            ...initialVideoState,
                        }
    
                    }
                }
            });
        }
        this.setState({
            statusTypes: {
                ...statusTypes,
                [deleteId]: {
                    ...statusTypes[deleteId],
                    title: `${this.getTitleForNotes()} ${this.getPageNumber(deleteId)}`,
                    key: 'createNotes',
                    state: 2,
                    visible: true,
                }
            },
        }, () => {
            const { statusTypes: stTypes } = this.state;
            const pageString = Object.keys(stTypes);
            let tempArrayForStatusData: any = [];
            for (let i = 1; i <= Object.keys(stTypes).length; i++) {
                if (`page${i}` !== deleteId) {
                    if (pageString.includes(`page${i}`)) {
                        tempArrayForStatusData.push(stTypes[`page${i}`])
                    }
                }
                else {
                    tempArrayForStatusData.push(stTypes[deleteId]);
                }
            }
            let copyInSectionContent = inSectionContent;
            copyInSectionContent[0] = {
                ...copyInSectionContent[0],
                subType: [...tempArrayForStatusData],
                state: 3,
            }
            this.setState({
                inSectionContent: [
                    ...copyInSectionContent
                ]
            }, () => {

                this.props.setPageInContent([...this.state.inSectionContent]);
                this.handleFilledData(deleteId, 'video');
            });
        });
    }

    handleCloseDialog = () => {
        this.setState({
            deletePopUpDialog: false,
            deletePopUpDialogforPage: false
        })
    }

    handleVideoSelect = (event: any) => {

        // alert(event.target.files[0]);
        // this.setState({
        //     isUploadStart: true,
        // })

        let file: any = null;
        // //On paste
        // if (event.clipboardData && event.clipboardData.files) {
        //     file = event.clipboardData.files[0]
        // }
        //On upload 
        if (event.target.files) {
            file = event.target.files[0]
        }
        //On Drop 
        if (event.dataTransfer && event.dataTransfer.files) {
            file = event.dataTransfer.files[0]
        }
        this.props.showVideoModal(true);
    }

    handleChooseFromLibrary = (pageKeyName: any) => {

        let goalsDriller: any = {};
        this.setState({
            chooseLibraryKey: pageKeyName,
            selectedQuestionCount: 0,
        })
        let preSelectedFilterContent = {
            contentMenu: "all",
            goalsDriller: {},
            contentFilterData: [{
                filterValue: FilterValues.contentType,
                isSelected: true,
                disabled: false,
                filters: [{
                    filterValue: FilterValues.question,
                    isSelected: true,
                    disabled: false,
                    filters: []
                }
                ]
            },
            {
                filterValue: FilterValues.status,
                isSelected: true,
                filters: [{
                    filterValue: "PUBLISHED",
                    isSelected: true,
                    filters: []
                }],
            }
            ]
        }
        this.setState({
            preSelectedFilterContent,
            selectQuestionDialogOpen: true,
        })
    }

    handleChooseFromVideoLibrary = (pageKeyName: any, type?: string) => {
        let goalsDriller: any = {};
        this.setState({
            chooseLibraryKey: pageKeyName,
            selectedQuestionCount: 0,
        })
        let preSelectedFilterContent = {
            contentMenu: "all",
            goalsDriller: {},
            contentFilterData: [{
                filterValue: FilterValues.contentType,
                isSelected: true,
                disabled: false,
                filters: [{
                    filterValue: 'studymaterial',
                    isSelected: true,
                    disabled: false,
                    filters: [{
                        filterValue: type ? type : 'videos',
                        isSelected: true,
                        filters: [],
                    }]
                }
                ]
            },
            {
                filterValue: FilterValues.status,
                isSelected: true,
                filters: [{
                    filterValue: "PUBLISHED",
                    isSelected: true,
                    filters: []
                }],
            }
            ]
        }
        this.setState({
            preSelectedFilterContent,
            selectVideoDialogOpen: true,
            contentType: type || '',
        })
    }
    handleChooseFromAudioLibrary = (pageKeyName: any) => {
        let goalsDriller: any = {};
        this.setState({
            chooseLibraryKey: pageKeyName,
            selectedQuestionCount: 0,
        })
        let preSelectedFilterContent = {
            contentMenu: "all",
            goalsDriller: {},
            contentFilterData: [{
                filterValue: FilterValues.contentType,
                isSelected: true,
                disabled: false,
                filters: [{
                    filterValue: 'studymaterial',
                    isSelected: true,
                    disabled: false,
                    filters: [{
                        filterValue: 'audios',
                        isSelected: true,
                        filters: [],
                    }]
                }
                ]
            },
            {
                filterValue: FilterValues.status,
                isSelected: true,
                filters: [{
                    filterValue: "PUBLISHED",
                    isSelected: true,
                    filters: []
                }],
            }
            ]
        }
        this.setState({
            preSelectedFilterContent,
            selectVideoDialogOpen: true,
        })
    }

    setMathInstance = (mathEditor: any) => {
        this.setState({ mathEditor })
    }

    withContent = () => {
        const {
            selectedQuestionCount
        } = this.state;

        let { selectQuestionDialogOpen } = this.state;
        const { classes } = this.props;
        const otherDialogProps = {
            fullScreen: true,
        };
        let { selectedTempQuestions, filterSelectedQuestion, selectedTrackedQuestionIds, preSelectedFilterContent } = this.state;
        const questionLimit = this.getQuestionLimitForNotes();

        return (
            <Dialog
                {...otherDialogProps}
                open={selectQuestionDialogOpen}>

                <div style={{ width: 'auto' }}>
                    <DialogTitle classes={{ root: classes.dialogTitle }}>
                        <>
                            <Grid container justify="space-between" alignItems="center">
                                <Grid item xs="auto">
                                    <Typography
                                        color="textPrimary"
                                        variant="body1"
                                        style={{ cursor: 'pointer' }}
                                        onClick={this.handleBackToTestpaperClick.bind(this)}
                                    >
                                        <BackIcon classes={{ root: classes.backIconRoot }} />
                                        <strong>Back to Study Material Notes</strong>
                                    </Typography>
                                </Grid>
                                <Grid item xs />
                                <Grid item xs="auto">
                                    <Typography variant="caption" inline>
                                        <b style={{ marginRight: '20px', fontSize: 16, }}>{selectedQuestionCount}/{questionLimit} Selected</b>
                                    </Typography>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => this.handleAddContentClick()}
                                        disabled={selectedQuestionCount > questionLimit || selectedQuestionCount === 0  }
                                    >
                                        Add Content
                  </Button>
                                </Grid>
                            </Grid>
                        </>
                    </DialogTitle>
                    <DialogContent classes={{ root: classes.dialogContent }}>
                        <PerfectScrollbar className={`dialog-content ${classes.perfectScrollbar}`}>
                            <WithContent
                                isInPopUp={true}
                                selectedQuestions={selectedTempQuestions}
                                selectedTrackedQuestionIds={selectedTrackedQuestionIds}
                                filterSelectedQuestion={filterSelectedQuestion}
                                onContentSelect={this.handleContentSelect.bind(this)}
                                onContentSelectAll={this.handleContentSelectAll.bind(this)}
                                onCheckContentExist={this.handleCheckContentExist.bind(this)}
                                selectedFilterContent={preSelectedFilterContent}
                                fromTestPaper={true}
                                type={this.props.type}
                                removeDisabilityFromCheckBox={true}
                                isSelectAllRequired={questionLimit !== 1}
                                contentCreateOption={false}
                                fromNotes={true}
                                bucketsToDisplay={[CONTENT_SECTION_TYPES[0]]}
                                preSelectedBucket={CONTENT_SECTION_KEYS.GLORIFIRE}
                            />
                        </PerfectScrollbar>
                    </DialogContent>
                </div>
            </Dialog>
        )
    }

    withVideoContent = () => {
        const {
            selectedQuestionCount
        } = this.state;

        let { selectVideoDialogOpen } = this.state;
        const { classes } = this.props;
        const otherDialogProps = {
            fullScreen: true,
        };
        let selectedQuestionsCount = 0;
        let { selectedTempQuestions, selectedTrackedQuestionIds, preSelectedFilterContent } = this.state;
        return (
            <Dialog
                {...otherDialogProps}
                open={selectVideoDialogOpen}>

                <div style={{ width: 'auto' }}>
                    <DialogTitle classes={{ root: classes.dialogTitle }}>
                        <>
                            <Grid container justify="space-between" alignItems="center">
                                <Grid item xs="auto">
                                    <Typography
                                        color="textPrimary"
                                        variant="body1"
                                        style={{ cursor: 'pointer' }}
                                        onClick={this.handleBackToTestpaperClick.bind(this)}
                                    >
                                        <BackIcon classes={{ root: classes.backIconRoot }} />
                                        <strong>Back to Study Material Notes</strong>
                                    </Typography>
                                </Grid>
                                <Grid item xs />
                                <Grid item xs="auto">
                                    <Typography variant="caption" inline>
                                        <b style={{ marginRight: '20px', fontSize: 16, }}>{selectedQuestionCount}/ 1 Selected</b>
                                    </Typography>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        disabled={selectedQuestionCount < 1 || selectedQuestionCount > 1}
                                        onClick={() => this.handleAddContentVideoClick()}
                                    >
                                        Add Content
                  </Button>
                                </Grid>
                            </Grid>
                        </>
                    </DialogTitle>
                    <DialogContent classes={{ root: classes.dialogContent }}>
                        <PerfectScrollbar className={`dialog-content ${classes.perfectScrollbar}`}>
                            <WithContent
                                isInPopUp={true}
                                selectedQuestions={selectedTempQuestions}
                                selectedTrackedQuestionIds={selectedTrackedQuestionIds}
                                onContentSelect={this.handleContentSelect.bind(this)}
                                onContentSelectAll={this.handleContentSelectAll.bind(this)}
                                onCheckContentExist={this.handleCheckContentExist.bind(this)}
                                selectedFilterContent={preSelectedFilterContent}
                                fromTestPaper={true}
                                type={this.props.type}
                                removeDisabilityFromCheckBox={true}
                                isSelectAllRequired={false}
                                contentCreateOption={false}
                                fromNotes={true}
                                bucketsToDisplay={[CONTENT_SECTION_TYPES[0]]}
                                preSelectedBucket={CONTENT_SECTION_KEYS.GLORIFIRE}
                            />
                        </PerfectScrollbar>
                    </DialogContent>
                </div>
            </Dialog>
        );
    }

    withAudioContent = () => {
        const {
            selectedQuestionCount
        } = this.state;

        let { selectVideoDialogOpen } = this.state;
        const { classes } = this.props;
        const otherDialogProps = {
            fullScreen: true,
        };
        let selectedQuestionsCount = 0;
        let { selectedTempQuestions, selectedTrackedQuestionIds, preSelectedFilterContent } = this.state;
        return (
            <Dialog
                {...otherDialogProps}
                open={selectVideoDialogOpen}>

                <div style={{ width: 'auto' }}>
                    <DialogTitle classes={{ root: classes.dialogTitle }}>
                        <>
                            <Grid container justify="space-between" alignItems="center">
                                <Grid item xs="auto">
                                    <Typography
                                        color="textPrimary"
                                        variant="body1"
                                        style={{ cursor: 'pointer' }}
                                        onClick={this.handleBackToTestpaperClick.bind(this)}
                                    >
                                        <BackIcon classes={{ root: classes.backIconRoot }} />
                                        <strong>Back to Study Material Notes</strong>
                                    </Typography>
                                </Grid>
                                <Grid item xs />
                                <Grid item xs="auto">
                                    <Typography variant="caption" inline>
                                        <b style={{ marginRight: '20px', fontSize: 16, }}>{selectedQuestionCount}/ 1 Selected</b>
                                    </Typography>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        disabled={selectedQuestionCount < 1 || selectedQuestionCount > 1}
                                        onClick={() => this.handleAddContentAudioClick()}
                                    >
                                        Add Content
                  </Button>
                                </Grid>
                            </Grid>
                        </>
                    </DialogTitle>
                    <DialogContent classes={{ root: classes.dialogContent }}>
                        <PerfectScrollbar className={`dialog-content ${classes.perfectScrollbar}`}>
                            <WithContent
                                isInPopUp={true}
                                selectedQuestions={selectedTempQuestions}
                                selectedTrackedQuestionIds={selectedTrackedQuestionIds}
                                onContentSelect={this.handleContentSelect.bind(this)}
                                onContentSelectAll={this.handleContentSelectAll.bind(this)}
                                onCheckContentExist={this.handleCheckContentExist.bind(this)}
                                selectedFilterContent={preSelectedFilterContent}
                                fromTestPaper={true}
                                type={this.props.type}
                                removeDisabilityFromCheckBox={true}
                                isSelectAllRequired={false}
                                contentCreateOption={false}
                                bucketsToDisplay={[CONTENT_SECTION_TYPES[0]]}
                                preSelectedBucket={CONTENT_SECTION_KEYS.GLORIFIRE}
                            />
                        </PerfectScrollbar>
                    </DialogContent>
                </div>
            </Dialog>
        );
    }
    handleDeletePageWithPopUpPage = (pageKey: any) => {
        this.setState({
            deletePopUpDialogforPage: false
        }, () => {
            this.handleDeletePage(pageKey)
        })
    }


    addPageComponent = (element: any, count: any = 0): any => {
        const pageName = `${this.getTitleForNotes()} ${count + 1}`;
        const pageNameKey = `page${count + 1}`;
        const sectionId = `page-${count}`;
        const { classes, pageTabState: { [`page${count + 1}`]: { activeTab = 1 } = {} } } = this.props;
        return (
            <>
                <div className={classes.tabsAlign} style={{ paddingTop: '10px', }}>
                    <Typography
                        variant="h6"
                    >
                        {pageName}
                    </Typography>
                    <div style={{ display: 'flex' }}>
                        <WrapperComponent pageNumber={count + 1} filledTab={this.state.filledTab} />
                        {pageNameKey !== PageKeys.page1 && (
                            <>
                                <IconButton
                                    className={classes.tabsNotes}
                                    style={{ marginLeft: '20px', minWidth: '44px', height: '44px', alignSelf: 'center' }}
                                    disabled={pageNameKey === PageKeys.page1 || this.state.isDisabled}
                                    onClick={() => this.setState({
                                        deletePopUpDialogforPage: true,
                                        deleteKey: pageNameKey,
                                    })}
                                >
                                    {/* <CloseIcon
                                fontSize="large"
                            /> */}
                                    <img alt="Cancel video upload" src="/assets/svg/learn/closePanel.svg" style={{ cursor: 'pointer', }} />

                                </IconButton>
                                <DeletePopUp
                                    openDialog={this.state.deletePopUpDialogforPage}
                                    handleClose={this.handleCloseDialog}
                                    deleteFunction={() => this.handleDeletePageWithPopUpPage(this.state.deleteKey)}
                                />
                            </>
                        )}
                    </div>
                </div>

                <div>
                    {activeTab === 1 &&
                        <TheoryTab history={history}
                            actionType={this.props.actionType}
                            type={this.props.type}
                            notesData={this.props.notesData}
                            handleNotesData={this.props.handleNotesData}
                            subType={this.props.subType}
                            pageKey={pageNameKey}
                            handlePageState={this.handlePageState}
                            errorMessage={this.state.errorMessage}
                            sectionId={sectionId}
                        />}
                    {activeTab === 3 &&
                        <QuestionTab
                            history={history}
                            actionType={this.props.actionType}
                            type={this.props.type}
                            notesData={this.props.notesData}
                            handleNotesData={this.props.handleNotesData}
                            subType={this.props.subType}
                            pageKey={pageNameKey}
                            inSectionContent={this.state.inSectionContent}
                            handleStatusTypes={this.handleStatusTypes}
                            handleFilledData={this.handleFilledData}
                            checkAllPageStateKeys={this.checkAllPageStateKeys}
                            handleSectionInContent={this.handleSectionInContent}
                            filterSelectedQuestion={this.state.filterSelectedQuestion}
                            handleFilterSelectedQuestion={this.handleFilterSelectedQuestion}
                            handlePageState={this.handlePageState}
                            handleDeleteQuestions={this.handleDeleteQuestions}
                            handleChooseFromLibrary={this.handleChooseFromLibrary}
                            handleAddContent={this.handleAddContentClick}
                            handleReplaceQuestion={this.handleReplaceQuestion}
                            handleSearchId={this.handleSearchId}
                            handleSearchFocus={this.handleSearchFocus}
                            handleSuggestedQuestionClick={this.handleSuggestedQuestionClick}
                            closeSuggestedQuestions={this.closeSuggestedQuestions}
                            questionsList={this.state.questionsList}
                            suggestedQuestions={this.state.suggestedQuestions}
                            showSuggestedConcept={this.state.showSuggestedConcept}
                            saveQuestionsList={this.saveQuestionsList}
                            sectionId={sectionId}
                        />}
                    {activeTab === 5 &&
                        <VideoTab
                            pageKey={pageNameKey}
                            handlePageState={this.handlePageState}
                            notesData={this.props.notesData}
                            handleChooseFromVideoLibrary={this.handleChooseFromVideoLibrary}
                            handleAddContent={this.handleAddContentVideoClick}
                            handleDeleteVideo={this.handleDeleteVideo}
                            handleReplaceVideo={this.handleReplaceVideo}
                            handleNotesData={this.props.handleNotesData}
                            updateCustomKeys={this.updateCustomKeys}
                            sectionId={sectionId}
                        />}
                    {activeTab === 4 &&
                        <VideoTab
                            addOnlyAudio={true}
                            pageKey={pageNameKey}
                            handlePageState={this.handlePageState}
                            notesData={this.props.notesData}
                            handleChooseFromVideoLibrary={this.handleChooseFromVideoLibrary}
                            handleAddContent={this.handleAddContentVideoClick}
                            handleDeleteVideo={this.handleDeleteVideo}
                            handleReplaceVideo={this.handleReplaceVideo}
                            handleNotesData={this.props.handleNotesData}
                            updateCustomKeys={this.updateCustomKeys}
                            sectionId={sectionId}
                        />}  
                    {/* need to add css in this component*/}

                </div>
            </>
        )

    }

    addQuestionComponent = (count: number) => {

        const pageName = `Question ${count + 1}`;
        const pageNameKey = `page${count + 1}`;
        const sectionId = `page-${count}`;
        const { classes, pageTabState: { [`page${count + 1}`]: { activeTab = 1 } = {} } } = this.props;

        return (
            <>
                <div className={classes.tabsAlign} style={{ paddingTop: '10px', }}>
                    <Typography
                        variant="h6"
                    >
                        {pageName}
                    </Typography>
                    <div style={{ display: 'flex' }}>

                        {pageNameKey !== PageKeys.page1 && (
                            <>
                                <IconButton
                                    className={classes.tabsNotes}
                                    style={{ marginLeft: '20px' }}
                                    disabled={pageNameKey === PageKeys.page1 || this.state.isDisabled}
                                    onClick={() => this.setState({
                                        deletePopUpDialogforPage: true,
                                        deleteKey: pageNameKey,
                                    })}
                                >
                                    {/* <CloseIcon
                                fontSize="large"
                            /> */}
                                    <img alt="Cancel video upload" src="/assets/svg/learn/closePanel.svg" style={{ cursor: 'pointer', }} />
                                </IconButton>
                            </>
                        )}
                    </div>
                </div>
                <div>
                    <ObjectiveQuestionTab
                        history={history}
                        actionType={this.props.actionType}
                        type={this.props.type}
                        notesData={this.props.notesData}
                        handleNotesData={this.props.handleNotesData}
                        subType={this.props.subType}
                        pageKey={pageNameKey}
                        inSectionContent={this.state.inSectionContent}
                        handleStatusTypes={this.handleStatusTypes}
                        handleFilledData={this.handleFilledData}
                        checkAllPageStateKeys={this.checkAllPageStateKeys}
                        handleSectionInContent={this.handleSectionInContent}
                        filterSelectedQuestion={this.state.filterSelectedQuestion}
                        handleFilterSelectedQuestion={this.handleFilterSelectedQuestion}
                        handlePageState={this.handlePageState}
                        handleDeleteQuestions={this.handleDeleteQuestions}
                        handleChooseFromLibrary={this.handleChooseQuestionFromLibrary}
                        handleAddContent={this.handleAddContentClick}
                        handleReplaceQuestion={this.handleReplaceQuestion}
                        handleSearchId={this.handleSearchId}
                        handleSearchFocus={this.handleSearchFocus}
                        handleSuggestedQuestionClick={this.handleSuggestedQuestionClick}
                        closeSuggestedQuestions={this.closeSuggestedQuestions}
                        questionsList={this.state.questionsList}
                        suggestedQuestions={this.state.suggestedQuestions}
                        showSuggestedConcept={this.state.showSuggestedConcept}
                        saveQuestionsList={this.saveQuestionsList}
                        sectionId={sectionId}
                        isArchiveNotes={this.isArchiveNotes}
                    />
                </div>
            </>
        )
    }
    _setSubjects = (evt: any) => {
        this.setState({
            setConceptAndPages: evt
        }, () => {
            const { setConceptAndPages } = this.state;
            this.props.handleNotesData({ subjects: [...setConceptAndPages] });
            if (setConceptAndPages.length !== 0) {
                let setAddConceptState = [...this.state.inSectionContent];
                setAddConceptState[1] = { ...setAddConceptState[1], state: 1 }
                this.setState({
                    inSectionContent: [...setAddConceptState],
                }, () => {
                    this.props.setPageInContent([...this.state.inSectionContent]);
                })
            }
            else {
                let setAddConceptState = this.state.inSectionContent;
                setAddConceptState[1] = { ...setAddConceptState[1], state: 3 }
                this.setState({
                    inSectionContent: setAddConceptState,
                }, () => {
                    this.props.handleNotesData({ subjects: [...setConceptAndPages] });
                    this.props.setPageInContent([...this.state.inSectionContent]);
                })
            }
        });
    }

    _setSecondarySubjects = (evt: any) => {
        this.setState({
            setConceptAndPages: evt
        }, () => {
            this.props.handleNotesData({ secondarySubjects: [...this.state.setConceptAndPages] });
        })
    }

    validateTags = function (inContentCopy: any, tagsList: any[], tags: any[]) {
        let requiredCount = 0
        let requiredMeet = 0
        tagsList.forEach(t => {
            if (t.isCompulsory) {
                requiredCount++;
                if (tags && tags.length > 0) {
                    tags.forEach((pt: any) => {
                        if (pt.relation && pt.relation.id && t._id == pt.relation.id) {
                            if (pt.values && pt.values[0]) {
                                requiredMeet++;
                            }
                        }
                    })
                }
            }
        });

        const status = requiredCount !== requiredMeet ? 3 : 1;
        inContentCopy[2].state = status;
        return inContentCopy;
    }

    _setTags = (evt: any) => {
        const { tagsList } = this.props;
        const { inSectionContent } = this.state
        const validationsCopy = JSON.parse(JSON.stringify(inSectionContent));
        const stateUpdateOfTags = this.validateTags(validationsCopy, tagsList, evt)
        this.props.handleNotesData({ tags: evt });
        this.setState({
            tags: evt,
            inSectionContent: stateUpdateOfTags
        }, () => {
            this.props.setPageInContent([...this.state.inSectionContent])
        })
    }

    randomString = (length: number) => {
        let mask = '';
        mask += 'abcdefghijklmnopqrstuvwxyz';
        mask += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        mask += '0123456789';
        let result = '';
        for (let i = length; i > 0; --i) 
           result += mask[Math.round(Math.random() * (mask.length - 1))];
        return result;
    }

    setAttachments = (attachments: Attachment[]) => {
        const { inSectionContent } = this.state;
        const { notesData} = this.props;
        const pdfPassword = notesData.content ? notesData.content.pages.length > 0 ? notesData.content.pages[0].code:'':'';
        this.setState({
            pdfFileAttachment: attachments,
            pdfUrl: '',
            password:pdfPassword,
        },()=>{ this.addUploadFileInSection();});
        this.props.setNotesPdfFile(attachments);
        this.props.handleNotesData({ pdfUrl: '',pdfPassword});

      };
    
       handlePageChange = (e: PageChangeEvent) => {
        let event:PageChangeEvent = Object.assign({}, e)
       
        let data = JSON.parse(JSON.stringify(this.state.pdfPageData));
        const { notesData} = this.props;
        if(notesData.content && notesData.content.pages.length>0){
            this.setState({
                password: notesData.content.pages[0].code
            })
        }
        if(data.currentPage != event.currentPage + 1) {
            data.currentPage =event.currentPage+1

            // this.setState({
            //     pdfPageData : data
            //   })
        }

        localStorage.setItem('current-page', e.currentPage.toString());
    };
     onDocumentLoad = (e: DocumentLoadEvent) => {
         let event:DocumentLoadEvent = e
        
        let data = JSON.parse(JSON.stringify(this.state.pdfPageData))
        if(data.totalPages != event.doc.numPages) {
            data.totalPages = event.doc.numPages ;

            this.setState({
                pdfPageData : data
              })
        }
      localStorage.setItem('total-page', e.doc.numPages.toString());
      //return  (e.doc.numPages)
  };

    handleSelectChange=(e: any)=> {
        const type = e.target.classList.value.includes('pwTab1') ? 'Pdf Notes' : 'WorkBook'
        this.setState({...this.state, pdfType: type})
            this.props.handleNotesData({pdfType: type})
    }

    getQuestionLimitForNotes() {
        const notesType = this.getNotesType(_.get(this.props.notesData, 'content.subType', ''));
        return notesType === NOTES_TYPE.SIMPLE_NOTES || this.state.replaceQuestion ? 1 : 50;
    }

    getCurrentNotesComponent = () => {

        const { title = '', errorMessage, activeTab, pdfFileAttachment, pdfPageData, pdfUrl, pdfType, subHeadingSettings: subHeadingList, 
                 errorListForSubHeadingRange} = this.state;
        const notesTitle = this.props.notesData && this.props.notesData.title;
        const { classes, notesData: { pageState = {}, } = {}, editRights } = this.props;
        const password = this.props.notesData.content && this.props.notesData.content.pages && this.props.notesData.content.pages.length && this.props.notesData.content.pages[0].metaData.pdf && this.props.notesData.content.pages[0].metaData.pdf.code;
        const notesType = this.getNotesType(_.get(this.props.notesData, 'content.subType', ''));

        switch (notesType) {
            case NOTES_TYPE.SUBJECTIVE_NOTES:

                return <CreateSubjectiveNotes classes={classes} editRights={editRights} isError={this.isError} title={title}
                    notesTitle={notesTitle} handleInputChange={this.handleInputChange} errorMessage={errorMessage}
                    setAttachments={this.setAttachments} pdfFileAttachment={pdfFileAttachment} pdfType={pdfType}
                    pdfPageData={pdfPageData} pdfUrl={pdfUrl} password={password}
                    handlePageChange={this.handlePageChange} onDocumentLoad={this.onDocumentLoad} 
                    getTitlePlaceHolder={this.getTitlePlaceHolder}
                    />;

            case NOTES_TYPE.OBJECTIVE_NOTES:
                return (<CreateObjectiveNotes classes={classes} editRights={editRights} isError={this.isError} title={title}
                    notesTitle={notesTitle} handleInputChange={this.handleInputChange} errorMessage={errorMessage}
                    pageState={pageState} addPageComponent={this.addQuestionComponent} handleAddPage={this.handleAddPage}
                    subHeadingList={subHeadingList} handleSubHeadingChange={this.handleSubHeadingChange} 
                    errorListForSubHeading={errorListForSubHeadingRange} addNewSubHeading={this.addNewSubHeading}
                    getTitlePlaceHolder={this.getTitlePlaceHolder} isArchiveNotes={this.isArchiveNotes}
                />)

            default:
                return (<CreateNotes classes={classes} editRights={editRights} isError={this.isError} title={title}
                    notesTitle={notesTitle} handleInputChange={this.handleInputChange} errorMessage={errorMessage}
                    activeTab={activeTab} setActiveTab={this.setActiveTab} pageState={pageState}
                    addPageComponent={this.addPageComponent} handleAddPage={this.handleAddPage}
                    setAttachments={this.setAttachments} pdfFileAttachment={pdfFileAttachment} pdfType={pdfType}
                    handleSelectChange={this.handleSelectChange} pdfPageData={pdfPageData} pdfUrl={pdfUrl} password={password}
                    handlePageChange={this.handlePageChange} onDocumentLoad={this.onDocumentLoad} />)
        }
    }


    render = () => {
    
        const { classes, type, notesData: {  subjects = [], tags = [] } = {}, editRights } = this.props;
        return (
            <>
                <div className={cx(classes.createPraticeSetBlock, classes.hideX)}>
                {this.getCurrentNotesComponent()}
            </div>
                <AddConceptOrChapter
                    isDisable={!editRights.includes('syllabus')}
                    sectionId="addConceptsAndChapters"
                    defaultExpanded={false}
                    formData={_.isUndefined(subjects) ? [] : JSON.parse(JSON.stringify(subjects))}
                    handleFormChange={this._setSubjects}
                    allowSecondarySubjects
                    secondarySubjects={JSON.parse(JSON.stringify(this.props.notesData.secondarySubjects))}
                    handleSecondarySubjectChange={this._setSecondarySubjects}
                    contentType={CONTENT_TYPE.NOTES}

                />
                <AddExtraTags
                    isDisable={!editRights.includes('tags')}
                    isRequired
                    formData={_.isUndefined(tags) ? [] : JSON.parse(JSON.stringify(tags))}
                    handleFormChange={this._setTags}
                    contentType={type}
                    defaultExpanded={true}
                />
                {
                    this.withContent()
                }
                {
                    this.withVideoContent()
                }
                <DeletePopUp
                    openDialog={this.state.deletePopUpDialogforPage}
                    handleClose={this.handleCloseDialog}
                    deleteFunction={() => this.handleDeletePageWithPopUpPage(this.state.deleteKey)}
                />
            </>
        );
    }
};

const mapStateToProps = (state: any) => {
    return {
        tagsList: _.get(state, 'mylibraryData.contentTags.list', []),
        prevSubTypesState: _.get(state, 'studyNotedReducers', []),
        pageTabState: _.get(state, 'wrapperTabsReducers.pageTabState', {}),
        isUploadModal: _.get(state, 'showVideoModalReducers.openModal', false),
        showVideo: _.get(state, 'videoUploadedReducers.showVideo', false),
        notesData: _.get(state, 'studyMaterialReducer'),
        editRights: _.get(state, 'questionCreate.editRights', [])
    }
};

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
    setPageInContent: notesActions.addSubTypes,
    removeStyleInContent: notesActions.removeSubTypes,
    showMsg: showMsg,
    handleNotesData: studyActions.handleNotesData,
    setConceptAndChapters: notesActions.addConceptAndChapter,
    setTags: notesActions.addExtraTags,
    showVideoModal: showVideoModal,
    clearContentListData: contentActions.clearContentListData,
    setPractiseSetContent: notesActions.setPractiseSetContent
}, dispatch);
// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(StudyNotesCreate));